import SolutionTemplate from "./SolutionTemplate";

const AttendanceSolution = () => (
  <SolutionTemplate
    eyebrow="Attendance management"
    title="Photo-verified check-ins across"
    titleGradient="every device"
    subtitle="Employees check in with a selfie on mobile, desktop or a shared kiosk. GPS coordinates, timestamp and facial match are recorded instantly — no buddy-punching, no disputes."
    heroImg="/assets/img/hero/Hero_Attendance_management.webp"
    heroImgAlt="TimeTango attendance management dashboard"
    chips={[
      { text: "Live now · 143 present", dot: true },
      { text: "Priya checked in ✓ Photo verified" },
    ]}
    flowSteps={[
      { title: "Tap check-in", desc: "Employee opens the app and taps the check-in button" },
      { title: "Face verify", desc: "Selfie is matched against the registered photo" },
      { title: "Marked present", desc: "Timestamp, GPS and photo are logged instantly" },
    ]}
    capabilities={[
      { icon: "📱", title: "Multi-device", desc: "Mobile, desktop, web and shared kiosk modes" },
      { icon: "📸", title: "Photo verification", desc: "Selfie match prevents buddy-punching" },
      { icon: "📍", title: "GPS tracking", desc: "Exact location captured at check-in and check-out" },
      { icon: "⏱", title: "Real-time dashboard", desc: "Live present/absent counts for admins" },
      { icon: "🔔", title: "Compliance alerts", desc: "Notify when employees miss check-in" },
      { icon: "📊", title: "Reports & export", desc: "Monthly compliance reports with Excel export" },
    ]}
    benefits={[
      { title: "Zero buddy-punching", desc: "Facial recognition ensures only the right person checks in." },
      { title: "Works offline", desc: "Mobile app queues check-ins when connectivity drops and syncs when back online." },
      { title: "Admin override", desc: "HR can add or edit attendance records with full audit trail." },
      { title: "Multi-location", desc: "Manage offices, warehouses, and client sites from one dashboard." },
    ]}
    relatedSlugs={["/solutions/leave", "/solutions/activity-tracking", "/solutions/timesheet"]}
    metaTitle="Attendance Management Software | TimeTango"
    metaDescription="Photo-verified GPS attendance for mobile, desktop and web. Real-time dashboards, compliance reports and zero buddy-punching. Start free trial."
  />
);

export default AttendanceSolution;
